import { useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FeatureContext } from "@/lib/i18n";

export const useTran = (namespace, options) => {
  const providerNamespace = useContext(FeatureContext);
  const activeNamespace = namespace || providerNamespace || "common";

  const featureNamespace = useMemo(() => {
    return activeNamespace === "common"
      ? "common"
      : [activeNamespace, "common"].flat(Infinity);
  }, [activeNamespace]);

  const result = useTranslation(featureNamespace, options);

  return {
    ...result,
    i18n: result.i18n,
    lng: result.i18n?.language,
    language: result.i18n?.language,
  };
};
